// MenuDropdown component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import IntlMessage from '../intl/intl_message.jsx'

import Popover from '../../../common/common/popover/popover.jsx'

class MenuDropdown extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false
    }
  }

  static get propTypes () {
    return {
      items: PropTypes.array,
      container: PropTypes.any,
      onClick: PropTypes.func,
      type: PropTypes.string,
      className: PropTypes.string,
      idx: PropTypes.number,
      target: PropTypes.any
    }
  }

  static get defaultProps () {
    return {
      items: [],
      container: null,
      onClick: null,
      type: '',
      className: '',
      idx: 0,
      target: null
    }
  }

  show () {
    this.setState({ active: true })
  }

  hide () {
    this.setState({ active: false })
  }

  render () {
    const _className = classnames(
      'menu-dropdown',
      {
        active: this.state.active,
        priority: this.props.type === 'priority'
      },
      this.props.className
    )

    return (
      <Popover
        key={this.props.idx}
        placement='bottom'
        container={this.props.container || this}
        className={_className}
        target={this.props.target}
        show={this.state.active}
        onHide={this.hide.bind(this)}
      >
        <ul className='menulist'>{this._renderItems()}</ul>
      </Popover>
    )
  }

  /* Event handlers */
  _onItemClick (item, idx, ev) {
    ev.preventDefault()

    if (this.props.onClick) {
      this.props.onClick(item, idx)
    }
  }

  /* Private Functions */
  _renderItems () {
    if (this.props.items && this.props.items.length > 0) {
      return this.props.items.map((item, idx) => {
        let _className = 'menuitem'
        if (this.props.type === 'priority') {
          _className = `${_className} ${_className}_${item.title.toLowerCase()}`
        }

        if (idx === 1 && !this.props.type === 'priority') {
          _className = 'menuitem alt'
        }

        return (
          <li
            className={_className}
            key={idx}
            onClick={this._onItemClick.bind(this, item, this.props.idx)}
          >
            {item.icon && <i className={`icon icon-${item.icon}`} />}
            <span className='title'>
              <IntlMessage ident={item.title} />
            </span>
          </li>
        )
      })
    }
    return ''
  }
}

export default MenuDropdown
